<template>
  <div id="loginscreen">
    <el-card shadow="hover" class="login-card">
      <div class="login-brand">
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120">
          <text x="55" y="50" font-size="20" fill="#f56c6c">Open</text>
          <text x="5" y="95" font-size="55" font-weight="700" fill="#303133">AS2</text>
        </svg>
      </div>

      <div class="login-title-group">
        <h1 class="login-title">{{ loading ? 'Signing in...' : 'Please sign in' }}</h1>
        <p class="login-subtitle">Connect to the OpenAS2 REST API with your Basic Auth credentials.</p>
      </div>

      <el-alert
        v-if="errored && errormsg"
        :title="String(errormsg)"
        type="error"
        :closable="false"
        class="login-alert"
      />

      <el-form @submit.native.prevent="login" label-position="top" class="login-form">
        <el-form-item label="Username">
          <el-input v-model="username" placeholder="Username" autocomplete="username" />
        </el-form-item>

        <el-form-item label="Password">
          <el-input
            v-model="password"
            placeholder="Password"
            show-password
            autocomplete="current-password"
            @keyup.enter.native="login"
          />
        </el-form-item>

        <el-form-item label="Server">
          <el-input v-model="server" placeholder="Server URL" @keyup.enter.native="login" />
        </el-form-item>

        <div class="login-actions">
          <el-checkbox v-model="rememberme">Remember me</el-checkbox>
          <el-button type="primary" :loading="loading" @click="login">Sign in</el-button>
        </div>
      </el-form>

      <p class="login-footer">© 2017-2019</p>
    </el-card>
  </div>
</template>

<script>
import store from '../store'
import axios from 'axios'

export default {
  name: 'login-screen',
  data: function () {
    return {
      username: '',
      password: '',
      server: process.env.VUE_APP_RESTAPI_URL || 'https://staging.as2.rit-ase.com/api',
      rememberme: false,
      loading: false,
      errormsg: '',
      errored: false,
    }
  },
  methods: {
    login: function (e) {
      if (e && e.preventDefault) e.preventDefault()
      this.errormsg = null
      this.errored = false

      var credentials = btoa(`${this.username}:${this.password}`)
      var basicAuth = 'Basic ' + credentials
      this.loading = true

      axios
        .get(this.server + '/', { headers: { Authorization: basicAuth } })
        .then((response) => {
          if (response.data.type == 'OK') {
            store.dispatch('loginAction', {
              user: this.username,
              pass: this.password,
              server: this.server,
            })
          } else {
            this.errored = true
            this.errormsg = response.data.result
          }
        })
        .catch((error) => {
          this.errored = true
          this.errormsg = error && error.message ? error.message : error
        })
        .finally(() => (this.loading = false))
    },
  },
}
</script>

<style scoped>
#loginscreen {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(180deg, #f8fbff 0%, #eef4ff 100%);
}

.login-card {
  width: 100%;
  max-width: 420px;
  border-radius: 18px;
}

.login-brand {
  display: flex;
  justify-content: center;
}

.login-title-group {
  text-align: center;
  margin: 8px 0 20px;
}

.login-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
}

.login-subtitle {
  margin: 8px 0 0;
  color: #909399;
}

.login-alert {
  margin-bottom: 16px;
}

.login-form {
  margin-top: 8px;
}

.login-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.login-footer {
  margin: 24px 0 0;
  text-align: center;
  color: #909399;
  font-size: 13px;
}
</style>
